import React from 'react'
import styled from 'styled-components'
import { Borders, Colors, FontWeights } from '../../constants'
import { useEthers } from '../../hooks'
import { shortenAddress } from '../../utils'
import { Copy, JazzIcon, Link } from '../icons'
import { Modal } from '../Modal'

interface Props {
  disconnect: () => void
  change: () => void
  onClose: () => void
}

export function WalletModal({ disconnect, change, onClose }: Props) {
  const { account, connector: existingConnector } = useEthers()

  if (account) {
    return (
      <Modal onClose={onClose} title="Account">
        <Content>
          <AccountActions>
            {existingConnector && (existingConnector as any).close && (
              <button type="button" onClick={disconnect}>
                Disconnect
              </button>
            )}
            <button type="button" onClick={change}>
              Change
            </button>
          </AccountActions>
          <Account>
            <JazzIcon address={account} size={36} border={'none'} />
            <Address>{shortenAddress(account)}</Address>
          </Account>
          <AddressOptions>
            <button
              onClick={() => {
                navigator.clipboard.writeText(account)
              }}
            >
              <CopyStyled />
              Copy Address
            </button>
            <a href={`https://etherscan.io/address/${account}`} target="_blank">
              <LinkStyled />
              View on Etherscan
            </a>
          </AddressOptions>
        </Content>
      </Modal>
    )
  } else {
    return <></>
  }
}

const Content = styled.div`
  padding: 20px;
`

const AccountActions = styled.div`
  display: flex;
  justify-content: flex-end;

  button {
    padding: 2px 5px;
    margin: 0 10px 0 0;
    display: block;
    font-size: 11px;
    color: ${Colors.DarkerGray};
    background: none;
    border: 1px solid ${Colors.DarkerGray};
    border-radius: ${Borders.Radius};
    text-transform: uppercase;
    cursor: pointer;

    &:hover {
      color: ${Colors.Hover};
      border: 1px solid ${Colors.Hover};
    }

    &:last-child {
      margin-right: 0;
    }
  }
`

const Account = styled.div`
  margin: 15px 0;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  border: 1px solid ${Borders.Color};
  border-radius: ${Borders.Radius};
`

const Address = styled.span`
  margin-left: 10px;
  font-size: 24px;
  font-weight: ${FontWeights.Bold};
`

const AddressOptions = styled.div`
  display: flex;
  justify-content: space-around;

  a,
  button {
    padding: 0;
    margin: 0 10px 0 0;
    display: flex;
    align-items: center;
    font-size: 11px;
    color: ${Colors.DarkerGray};
    background: none;
    border: 0;
    text-transform: uppercase;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      color: ${Colors.Hover};
    }

    &:last-child {
      margin-right: 0;
    }
  }
`

const CopyStyled = styled(Copy)`
  margin-right: 5px;
`

const LinkStyled = styled(Link)`
  margin-right: 5px;
`
